import TextInputAuth from "components/TextInputAuth";
import React from "react";

type Props = {
  firstEmail: string;
  setFirstEmail: React.Dispatch<React.SetStateAction<string>>;
  isHelpFirstEmail: any;
  helpTextFirstEmail: any;
  firstName: string;
  setFirstName: React.Dispatch<React.SetStateAction<string>>;
  isHelpFirstName: any;
  helpTextFirstName: any;
  secondName: string;
  setSecondName: React.Dispatch<React.SetStateAction<string>>;
  isHelpSecondName: any;
  helpTextSecondName: any;
  secondEmail: string;
  setSecondEmail: React.Dispatch<React.SetStateAction<string>>;
  isHelpSecondEmail: any;
  helpTextSecondEmail: any;
  secondFirstName: string;
  setSecondFirstName: React.Dispatch<React.SetStateAction<string>>;
  isHelpSecondFirstName: any;
  helpTextSecondFirstName: any;
  secondSecondName: string;
  setSecondSecondName: React.Dispatch<React.SetStateAction<string>>;
  isHelpSecondSecondName: any;
  helpTextSecondSecondName: any;
  checkEmail: (email: string, type: string) => void;
  disabledFirst?: boolean;
  disabledSecond?: boolean;
  setIsEditingEmail: (isEditingEmail: boolean) => void;
};

const AdoptiveInput: React.FC<Props> = ({
  firstEmail,
  setFirstEmail,
  isHelpFirstEmail,
  helpTextFirstEmail,
  firstName,
  setFirstName,
  isHelpFirstName,
  helpTextFirstName,
  secondName,
  setSecondName,
  isHelpSecondName,
  helpTextSecondName,
  checkEmail,
  secondEmail,
  setSecondEmail,
  isHelpSecondEmail,
  helpTextSecondEmail,
  secondFirstName,
  setSecondFirstName,
  isHelpSecondFirstName,
  helpTextSecondFirstName,
  secondSecondName,
  setSecondSecondName,
  isHelpSecondSecondName,
  helpTextSecondSecondName,
  disabledFirst,
  disabledSecond,
  setIsEditingEmail,
}): JSX.Element => {
  return (
    <div className="flex flex-row mx-auto">
      <div className="flex flex-col w-full">
        <div className="flex flex-row font-nunito font-normal text-xl text-black mb-1">
          Adoptive Family
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col w-1/3 mr-2">
            <TextInputAuth
              placeholder={"mandatory"}
              label="Email"
              value={firstEmail}
              onChange={(e: any) => {
                setIsEditingEmail(true);
                setFirstEmail(e.target.value);
                const emailValue = e.target.value;
                if (
                  emailValue &&
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
                ) {
                  checkEmail(emailValue, "firstAdoptiveFamily");
                }
              }}
              isHelp={isHelpFirstEmail}
              helpText={helpTextFirstEmail}
              // disabled={disabledFirst}
            />
          </div>
          <div className="flex flex-col w-1/3 mx-2">
            <TextInputAuth
              placeholder={"First Name"}
              label="First Name"
              value={firstName}
              onChange={(e: any) => {
                setFirstName(e.target.value);
                if (isHelpFirstName) {
                  setFirstName(e.target.value);
                }
              }}
              isHelp={isHelpFirstName}
              helpText={helpTextFirstName}
              disabled={disabledFirst}
            />
          </div>
          <div className="flex flex-col w-1/3 ml-2">
            <TextInputAuth
              placeholder={"Last Name"}
              label="Last Name"
              value={secondName}
              onChange={(e: any) => {
                setSecondName(e.target.value);
                if (isHelpSecondName) {
                  setSecondName(e.target.value);
                }
              }}
              isHelp={isHelpSecondName}
              helpText={helpTextSecondName}
              disabled={disabledFirst}
            />
          </div>
        </div>
        <div className="flex flex-row">
          <div className="flex flex-col w-1/3 mr-2">
            <TextInputAuth
              placeholder={"optional"}
              label="Email"
              value={secondEmail}
              onChange={(e: any) => {
                setIsEditingEmail(true);
                setSecondEmail(e.target.value);
                const emailValue = e.target.value;
                if (
                  emailValue &&
                  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(emailValue)
                ) {
                  checkEmail(emailValue, "secondAdoptiveFamily");
                }
              }}
              isHelp={isHelpSecondEmail}
              helpText={helpTextSecondEmail}
              // disabled={disabledSecond}
            />
          </div>
          <div className="flex flex-col w-1/3 mx-2">
            <TextInputAuth
              placeholder={"First Name"}
              label="First Name"
              value={secondFirstName}
              onChange={(e: any) => {
                setSecondFirstName(e.target.value);
                if (isHelpSecondFirstName) {
                  setSecondFirstName(e.target.value);
                }
              }}
              isHelp={isHelpSecondFirstName}
              helpText={helpTextSecondFirstName}
              disabled={disabledSecond}
            />
          </div>
          <div className="flex flex-col w-1/3 ml-2">
            <TextInputAuth
              placeholder={"Last Name"}
              label="Last Name"
              value={secondSecondName}
              onChange={(e: any) => {
                setSecondSecondName(e.target.value);
                if (isHelpSecondSecondName) {
                  setSecondSecondName(e.target.value);
                }
              }}
              isHelp={isHelpSecondSecondName}
              helpText={helpTextSecondSecondName}
              disabled={disabledSecond}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdoptiveInput;
